export const methods = {
  selectChanged(selected) {
    this.$emit("input", {
      ...this.value,
      value: Array.isArray(selected)
        ? selected.map((s) => ({ _id: s._id, name: s.name }))
        : selected,
    });
  },
  operatorChanged(operator) {
    this.$emit("input", {
      ...this.value,
      operator,
    });
  },
};
